import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=413a5d5c&"
import script from "./gift.vue?vue&type=script&lang=js&"
export * from "./gift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('413a5d5c')) {
      api.createRecord('413a5d5c', component.options)
    } else {
      api.reload('413a5d5c', component.options)
    }
    module.hot.accept("./gift.vue?vue&type=template&id=413a5d5c&", function () {
      api.rerender('413a5d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotSetting/gift/gift.vue"
export default component.exports